import { z } from 'zod';

const schema = z.object({
  VITE_API_BASE_URL: z.string().default(''),
  VITE_SOCKET_URL: z.string().min(1),
  VITE_GOOGLE_CLIENT_ID: z.string().min(1),
  VITE_APP_NAME: z.string().default('Weekend Game'),
  VITE_ENABLE_DEVTOOLS: z
    .union([z.string(), z.boolean()])
    .transform((v) => v === true || v === 'true')
    .default(false),
});

const parsed = schema.safeParse(import.meta.env);
if (!parsed.success) {
  console.error('Invalid environment variables:', parsed.error.flatten().fieldErrors);
  throw new Error('Missing/invalid VITE_* environment variables. See .env.example.');
}
export const env = parsed.data;
